//目前导入element-ui、router、axios、axios-mock-adapter、js-cookie和vuex
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import '@/styles/element-variables.scss';
import store from './store'
import i18n from './i18n'
import '@/plugins/authService' // 认证服务
import '@/permission' // permission control
//comment by xlx: 不要在main.js中启动拦截器！！！
//import '@/api/mock/user'  // 添加这行  
import './styles/dropdown.css'
import './styles/utilities.css'
import trackingService from '@/utils/tracking' // 火山引擎增长分析埋点
Vue.use(ElementUI);

Vue.config.productionTip = false


// 初始化埋点服务（支持火山引擎和 Google Tag Manager）
// 注意：SDK 脚本已在 index.html 中引入，这里只需要初始化配置
// trackingPlatform: 'volcengine' | 'google' | 'both' (默认: 'both')
trackingService.init({
  appId: process.env.VUE_APP_DATARANGERS_APP_ID || 20012071,
  channelDomain: process.env.VUE_APP_DATARANGERS_CHANNEL_DOMAIN || 'https://gator.volces.com',
  disableSdkMonitor: true,
  debug: process.env.VUE_APP_DATARANGERS_DEBUG === 'true' || process.env.VUE_APP_BUILD_ENV === 'dev', // 开发环境自动开启调试模式
  trackingPlatform: process.env.VUE_APP_TRACKING_PLATFORM || 'both' // 数据收集平台：'volcengine' | 'google' | 'both'
})

// 将埋点服务挂载到 Vue 原型上，方便在组件中使用
Vue.prototype.$tracking = trackingService

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
